(() => {
  const closeDrawer = (target) => {
    const drawer = target?.closest('header-drawer');
    drawer?.querySelector('.diffusione-mobile-menu__close')?.click();
  };

  document.addEventListener('click', (event) => {
    const submenuTrigger = event.target.closest('[data-diffusione-mobile-submenu]');
    if (submenuTrigger) {
      const menu = submenuTrigger.closest('.diffusione-mobile-menu');
      const panel = menu?.querySelector(`[data-diffusione-mobile-panel="${submenuTrigger.dataset.diffusioneMobileSubmenu}"]`);
      if (panel) {
        panel.hidden = false;
        panel.querySelector('[data-diffusione-mobile-back]')?.focus();
      }
      return;
    }

    const back = event.target.closest('[data-diffusione-mobile-back]');
    if (back) {
      const panel = back.closest('[data-diffusione-mobile-panel]');
      const menu = panel?.closest('.diffusione-mobile-menu');
      const trigger = menu?.querySelector(`[data-diffusione-mobile-submenu="${panel.dataset.diffusioneMobilePanel}"]`);
      panel.hidden = true;
      trigger?.focus();
      return;
    }

    if (event.target.closest('.diffusione-mobile-menu__cart, .diffusione-mobile-submenu [data-open-diffusione-modal]')) {
      closeDrawer(event.target);
      const preserveDialogLock = () => {
        if (document.querySelector('dialog[open]')) document.documentElement.setAttribute('scroll-lock', '');
      };
      setTimeout(preserveDialogLock, 0);
      setTimeout(preserveDialogLock, 400);
    }
  }, true);

  document.querySelectorAll('.menu-drawer-container').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (details.open) return;
      details.querySelectorAll('[data-diffusione-mobile-panel]').forEach((panel) => {
        panel.hidden = true;
      });
    });
  });
})();
